import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";
import {runInAction} from "mobx";

export class StoreGameContextHandler extends ActionHandler {
  type: ACTION_TYPES;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.type = ACTION_TYPES.onStoreGameContext;
  }

  async action(params) {
    if (!this.controller.device.isSmallView && !this.appStore.state.settings.isWidget) {
      runInAction(() => {
        this.appStore.state.context.setSelectedGame(params.game.domainModel);
        this.appStore.state.context.setSelectedTabIndex(params.tabIndex);
      })
    }
  }
}
